// LP Mock Data
// 6 counterparties, 12+ RFQs, quotes in all statuses, trades in every LpTradeStatus,
// price feeds, CBK reference, book context, competitive context, auto-quote rules,
// dealer limits, 15+ audit entries.

// ─── Counterparties ─────────────────────────────────────────────────────
export const mockCounterparties = [
  {
    id: 'cp-001',
    name: 'Mwamba Family Trust',
    type: 'trust',
    tier: 'tier_1',
    kycStatus: 'verified',
    kycExpiry: '2027-06-15',
    creditLimit: 5000000,
    creditUsed: 1200000,
    ssi: { bank: 'Stanbic Bank Kenya', account: 'KES-001-2234', swift: 'SBICKENX' },
    documents: [
      { type: 'trust_deed', label: 'Trust Deed', uploadedAt: '2026-01-10' },
      { type: 'source_of_funds', label: 'Source of Funds Declaration', uploadedAt: '2026-02-14' },
      { type: 'purpose_code', label: 'Purpose Code Certificate', uploadedAt: '2026-03-01' },
      { type: 'allocation_notice', label: 'Allocation Notice', uploadedAt: '2026-08-20' },
    ],
    contactName: 'Peter Mwamba',
    contactEmail: 'peter@mwambatrust.co.ke',
  },
  {
    id: 'cp-002',
    name: 'Horizon Impact Partners',
    type: 'holdco',
    tier: 'tier_1',
    kycStatus: 'verified',
    kycExpiry: '2027-03-20',
    creditLimit: 10000000,
    creditUsed: 3500000,
    ssi: { bank: 'Standard Chartered Kenya', account: 'USD-099-4410', swift: 'SCBLKENX' },
    documents: [
      { type: 'board_resolution', label: 'Board Resolution', uploadedAt: '2026-01-05' },
      { type: 'source_of_funds', label: 'Source of Funds Declaration', uploadedAt: '2026-01-20' },
      { type: 'purpose_code', label: 'Purpose Code Certificate', uploadedAt: '2026-02-01' },
      { type: 'allocation_notice', label: 'Allocation Notice', uploadedAt: '2026-09-01' },
    ],
    contactName: 'Victoria Chen',
    contactEmail: 'victoria@horizonimpact.com',
  },
  {
    id: 'cp-003',
    name: 'James Okonkwo',
    type: 'individual',
    tier: 'tier_2',
    kycStatus: 'verified',
    kycExpiry: '2027-01-10',
    creditLimit: 2000000,
    creditUsed: 450000,
    ssi: { bank: 'KCB Bank', account: 'KES-334-5567', swift: 'KCBLKENX' },
    documents: [
      { type: 'source_of_funds', label: 'Source of Funds Declaration', uploadedAt: '2026-04-15' },
      { type: 'purpose_code', label: 'Purpose Code Certificate', uploadedAt: '2026-04-15' },
    ],
    contactName: 'James Okonkwo',
    contactEmail: 'james@okonkwo.com',
  },
  {
    id: 'cp-004',
    name: 'Amina Diallo',
    type: 'individual',
    tier: 'tier_3',
    kycStatus: 'review_due',
    kycExpiry: '2026-10-01',
    creditLimit: 1000000,
    creditUsed: 200000,
    ssi: { bank: 'Equity Bank Uganda', account: 'UGX-221-8890', swift: 'EABORUGX' },
    documents: [
      { type: 'source_of_funds', label: 'Source of Funds Declaration', uploadedAt: '2025-10-01' },
    ],
    contactName: 'Amina Diallo',
    contactEmail: 'amina.d@gmail.com',
  },
  {
    id: 'cp-005',
    name: 'Savanna SFO Ltd',
    type: 'sfo',
    tier: 'tier_1',
    kycStatus: 'verified',
    kycExpiry: '2027-08-30',
    creditLimit: 8000000,
    creditUsed: 2100000,
    ssi: { bank: 'NCBA Bank', account: 'USD-550-7712', swift: 'NCBAKENX' },
    documents: [
      { type: 'board_resolution', label: 'Board Resolution', uploadedAt: '2026-02-10' },
      { type: 'source_of_funds', label: 'Source of Funds Declaration', uploadedAt: '2026-02-10' },
      { type: 'purpose_code', label: 'Purpose Code Certificate', uploadedAt: '2026-03-15' },
      { type: 'allocation_notice', label: 'Allocation Notice', uploadedAt: '2026-08-28' },
      { type: 'cb_form', label: 'Central Bank Form', uploadedAt: '2026-09-01' },
    ],
    contactName: 'Daniel Njeru',
    contactEmail: 'daniel@savannasfo.com',
  },
  {
    id: 'cp-006',
    name: 'Greenfield Capital',
    type: 'holdco',
    tier: 'tier_2',
    kycStatus: 'verified', // will flip to suspended after 60s in mock
    kycExpiry: '2027-05-15',
    creditLimit: 3000000,
    creditUsed: 900000,
    ssi: { bank: 'Co-operative Bank', account: 'KES-889-1123', swift: 'COOPKENX' },
    documents: [
      { type: 'source_of_funds', label: 'Source of Funds Declaration', uploadedAt: '2026-05-01' },
      { type: 'purpose_code', label: 'Purpose Code Certificate', uploadedAt: '2026-05-01' },
    ],
    contactName: 'Esther Wambui',
    contactEmail: 'esther@greenfieldcap.com',
  },
];

// ─── RFQs ───────────────────────────────────────────────────────────────
export const mockRfqs = [
  // Competitive RFQs
  {
    id: 'RFQ-5001',
    type: 'competitive',
    counterpartyId: 'cp-001',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 500000,
    purpose: 'investment',
    valueDate: '2026-09-14',
    deadline: new Date(Date.now() + 600000).toISOString(), // 10 min from now
    status: 'live',
    banksInvited: 4,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice', 'source_of_funds'],
  },
  {
    id: 'RFQ-5002',
    type: 'competitive',
    counterpartyId: 'cp-002',
    currencyPair: 'EUR/KES',
    side: 'sell',
    amount: 1200000,
    purpose: 'investment',
    valueDate: '2026-09-14',
    deadline: new Date(Date.now() + 900000).toISOString(),
    status: 'live',
    banksInvited: 3,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice', 'purpose_code'],
  },
  {
    id: 'RFQ-5003',
    type: 'competitive',
    counterpartyId: 'cp-003',
    currencyPair: 'GBP/UGX',
    side: 'sell',
    amount: 750000,
    purpose: 'capital_call',
    valueDate: '2026-09-15',
    deadline: new Date(Date.now() + 1200000).toISOString(),
    status: 'live',
    banksInvited: 5,
    aggregateGroupId: null,
    requiredDocs: ['source_of_funds'],
  },
  // Single dealer
  {
    id: 'RFQ-5004',
    type: 'single',
    counterpartyId: 'cp-005',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 2000000,
    purpose: 'investment',
    valueDate: '2026-09-14',
    deadline: new Date(Date.now() + 480000).toISOString(),
    status: 'live',
    banksInvited: 1,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice', 'source_of_funds', 'cb_form'],
  },
  // Standing order
  {
    id: 'RFQ-5005',
    type: 'standing',
    counterpartyId: 'cp-002',
    currencyPair: 'USD/KES',
    side: 'buy',
    amount: 800000,
    purpose: 'repatriation',
    valueDate: '2026-09-16',
    deadline: new Date(Date.now() + 1800000).toISOString(),
    status: 'live',
    banksInvited: 2,
    aggregateGroupId: null,
    requiredDocs: ['purpose_code'],
  },
  // Aggregate group
  {
    id: 'RFQ-5006',
    type: 'competitive',
    counterpartyId: 'cp-001',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 300000,
    purpose: 'investment',
    valueDate: '2026-09-14',
    deadline: new Date(Date.now() + 600000).toISOString(),
    status: 'live',
    banksInvited: 4,
    aggregateGroupId: 'AGG-001',
    requiredDocs: ['allocation_notice'],
  },
  {
    id: 'RFQ-5007',
    type: 'competitive',
    counterpartyId: 'cp-003',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 200000,
    purpose: 'investment',
    valueDate: '2026-09-14',
    deadline: new Date(Date.now() + 600000).toISOString(),
    status: 'live',
    banksInvited: 4,
    aggregateGroupId: 'AGG-001',
    requiredDocs: ['allocation_notice'],
  },
  // Missing docs — allocation notice missing for cp-004
  {
    id: 'RFQ-5008',
    type: 'single',
    counterpartyId: 'cp-004',
    currencyPair: 'USD/UGX',
    side: 'sell',
    amount: 350000,
    purpose: 'dividend',
    valueDate: '2026-09-15',
    deadline: new Date(Date.now() + 300000).toISOString(),
    status: 'live',
    banksInvited: 1,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice', 'source_of_funds'],
  },
  // Near-deadline
  {
    id: 'RFQ-5009',
    type: 'competitive',
    counterpartyId: 'cp-005',
    currencyPair: 'EUR/KES',
    side: 'sell',
    amount: 900000,
    purpose: 'investment',
    valueDate: '2026-09-14',
    deadline: new Date(Date.now() + 90000).toISOString(), // 90s from now
    status: 'live',
    banksInvited: 3,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice', 'source_of_funds'],
  },
  // Over-limit counterparty (cp-002 has 3.5M used of 10M, this pushes close)
  {
    id: 'RFQ-5010',
    type: 'competitive',
    counterpartyId: 'cp-002',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 7000000,
    purpose: 'investment',
    valueDate: '2026-09-16',
    deadline: new Date(Date.now() + 1200000).toISOString(),
    status: 'live',
    banksInvited: 4,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice', 'source_of_funds'],
  },
  // Suspended counterparty (cp-006 flips to suspended)
  {
    id: 'RFQ-5011',
    type: 'single',
    counterpartyId: 'cp-006',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 400000,
    purpose: 'investment',
    valueDate: '2026-09-15',
    deadline: new Date(Date.now() + 1500000).toISOString(),
    status: 'live',
    banksInvited: 1,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice'],
  },
  // Already awarded/expired
  {
    id: 'RFQ-5012',
    type: 'competitive',
    counterpartyId: 'cp-001',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 450000,
    purpose: 'investment',
    valueDate: '2026-09-12',
    deadline: '2026-09-11T14:00:00Z',
    status: 'awarded',
    banksInvited: 4,
    aggregateGroupId: null,
    requiredDocs: ['allocation_notice'],
  },
];

// ─── Quotes ─────────────────────────────────────────────────────────────
export const mockQuotes = [
  // Won quote
  {
    id: 'QT-7001',
    rfqId: 'RFQ-5012',
    counterpartyId: 'cp-001',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 450000,
    midRate: 129.40,
    margin: 0.15,
    clientRate: 129.55,
    counterAmount: 58297500,
    status: 'accepted',
    submittedAt: '2026-09-11T13:30:00Z',
    expiresAt: '2026-09-11T14:00:00Z',
    dealerName: 'Grace Mwangi',
    seniorApproval: null,
    offPolicy: false,
  },
  // Lost quote
  {
    id: 'QT-7002',
    rfqId: 'RFQ-5012',
    counterpartyId: 'cp-001',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 450000,
    midRate: 129.40,
    margin: 0.20,
    clientRate: 129.60,
    counterAmount: 58320000,
    status: 'rejected',
    submittedAt: '2026-09-11T13:25:00Z',
    expiresAt: '2026-09-11T14:00:00Z',
    dealerName: 'Grace Mwangi',
    seniorApproval: null,
    offPolicy: false,
  },
  // Expired quote
  {
    id: 'QT-7003',
    rfqId: 'RFQ-5012',
    counterpartyId: 'cp-001',
    currencyPair: 'EUR/KES',
    side: 'sell',
    amount: 600000,
    midRate: 142.10,
    margin: 0.25,
    clientRate: 142.35,
    counterAmount: 85410000,
    status: 'expired',
    submittedAt: '2026-09-10T10:00:00Z',
    expiresAt: '2026-09-10T10:30:00Z',
    dealerName: 'Grace Mwangi',
    seniorApproval: null,
    offPolicy: false,
  },
  // Declined (off-policy)
  {
    id: 'QT-7004',
    rfqId: 'RFQ-5008',
    counterpartyId: 'cp-004',
    currencyPair: 'USD/UGX',
    side: 'sell',
    amount: 350000,
    midRate: 3750.00,
    margin: 5.00,
    clientRate: 3755.00,
    counterAmount: 1314250000,
    status: 'withdrawn',
    submittedAt: '2026-09-12T08:00:00Z',
    expiresAt: '2026-09-12T08:30:00Z',
    dealerName: 'Grace Mwangi',
    seniorApproval: null,
    offPolicy: true,
  },
];

// ─── Trades ─────────────────────────────────────────────────────────────
export const mockTrades = [
  // CSD confirmed (fully settled)
  {
    id: 'TR-9001',
    quoteId: 'QT-7001',
    rfqId: 'RFQ-5012',
    counterpartyId: 'cp-001',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 450000,
    rate: 129.55,
    counterAmount: 58297500,
    status: 'csd_payment_confirmed',
    bankDealNo: 'EAB-FOREIGN-EXCHANGE-2026-0911-001',
    preFund: true,
    bookedAt: '2026-09-11T14:05:00Z',
    settlement: {
      valueDate: '2026-09-12',
      cutoffLocal: '2026-09-12T14:00:00+03:00',
      correspondent: 'Stanbic Bank Kenya',
      ssi: { bank: 'Stanbic Bank Kenya', account: 'KES-001-2234', swift: 'SBICKENX' },
    },
    confirmation: {
      bankConfirmed: true,
      venueConfirmed: true,
      mismatch: false,
      mismatchFields: [],
    },
  },
  // Awaiting funds (normal)
  {
    id: 'TR-9002',
    quoteId: null,
    rfqId: 'RFQ-5002',
    counterpartyId: 'cp-002',
    currencyPair: 'EUR/KES',
    side: 'sell',
    amount: 1200000,
    rate: 142.35,
    counterAmount: 170820000,
    status: 'awaiting_funds',
    bankDealNo: 'EAB-FOREIGN-EXCHANGE-2026-0912-001',
    preFund: true,
    bookedAt: '2026-09-12T09:15:00Z',
    settlement: {
      valueDate: '2026-09-14',
      cutoffLocal: '2026-09-14T14:00:00+03:00',
      correspondent: 'Standard Chartered Kenya',
      ssi: { bank: 'Standard Chartered Kenya', account: 'USD-099-4410', swift: 'SCBLKENX' },
    },
    confirmation: {
      bankConfirmed: true,
      venueConfirmed: true,
      mismatch: false,
      mismatchFields: [],
    },
  },
  // Late funds — past cutoff
  {
    id: 'TR-9003',
    quoteId: null,
    rfqId: 'RFQ-5003',
    counterpartyId: 'cp-003',
    currencyPair: 'GBP/UGX',
    side: 'sell',
    amount: 750000,
    rate: 4622.50,
    counterAmount: 3466875000,
    status: 'awaiting_funds',
    bankDealNo: 'EAB-FOREIGN-EXCHANGE-2026-0911-003',
    preFund: true,
    bookedAt: '2026-09-11T10:00:00Z',
    settlement: {
      valueDate: '2026-09-12',
      cutoffLocal: '2026-09-12T12:00:00+03:00', // already past
      correspondent: 'KCB Bank',
      ssi: { bank: 'KCB Bank', account: 'KES-334-5567', swift: 'KCBLKENX' },
    },
    confirmation: {
      bankConfirmed: true,
      venueConfirmed: false,
      mismatch: false,
      mismatchFields: [],
    },
  },
  // Confirmation mismatch
  {
    id: 'TR-9004',
    quoteId: null,
    rfqId: 'RFQ-5004',
    counterpartyId: 'cp-005',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 2000000,
    rate: 129.45,
    counterAmount: 258900000,
    status: 'confirmed',
    bankDealNo: 'EAB-FOREIGN-EXCHANGE-2026-0912-002',
    preFund: false,
    bookedAt: '2026-09-12T09:30:00Z',
    settlement: {
      valueDate: '2026-09-14',
      cutoffLocal: '2026-09-14T14:00:00+03:00',
      correspondent: 'NCBA Bank',
      ssi: { bank: 'NCBA Bank', account: 'USD-550-7712', swift: 'NCBAKENX' },
    },
    confirmation: {
      bankConfirmed: true,
      venueConfirmed: true,
      mismatch: true,
      mismatchFields: ['rate'],
      bankRate: 129.45,
      venueRate: 129.50,
    },
  },
  // Booked
  {
    id: 'TR-9005',
    quoteId: null,
    rfqId: 'RFQ-5005',
    counterpartyId: 'cp-002',
    currencyPair: 'USD/KES',
    side: 'buy',
    amount: 800000,
    rate: 129.30,
    counterAmount: 103440000,
    status: 'booked',
    bankDealNo: 'EAB-FOREIGN-EXCHANGE-2026-0912-003',
    preFund: false,
    bookedAt: '2026-09-12T10:00:00Z',
    settlement: {
      valueDate: '2026-09-16',
      cutoffLocal: '2026-09-16T14:00:00+03:00',
      correspondent: 'Standard Chartered Kenya',
      ssi: { bank: 'Standard Chartered Kenya', account: 'USD-099-4410', swift: 'SCBLKENX' },
    },
    confirmation: { bankConfirmed: false, venueConfirmed: false, mismatch: false, mismatchFields: [] },
  },
  // Released (pending settlement)
  {
    id: 'TR-9006',
    quoteId: null,
    rfqId: null,
    counterpartyId: 'cp-005',
    currencyPair: 'EUR/KES',
    side: 'sell',
    amount: 500000,
    rate: 142.20,
    counterAmount: 71100000,
    status: 'released',
    bankDealNo: 'EAB-FOREIGN-EXCHANGE-2026-0912-004',
    preFund: true,
    bookedAt: '2026-09-12T08:00:00Z',
    settlement: {
      valueDate: '2026-09-12',
      cutoffLocal: '2026-09-12T14:00:00+03:00',
      correspondent: 'NCBA Bank',
      ssi: { bank: 'NCBA Bank', account: 'USD-550-7712', swift: 'NCBAKENX' },
    },
    confirmation: { bankConfirmed: true, venueConfirmed: true, mismatch: false, mismatchFields: [] },
  },
  // SSI change
  {
    id: 'TR-9007',
    quoteId: null,
    rfqId: null,
    counterpartyId: 'cp-006',
    currencyPair: 'USD/KES',
    side: 'sell',
    amount: 400000,
    rate: 129.50,
    counterAmount: 51800000,
    status: 'instructed',
    bankDealNo: 'EAB-FOREIGN-EXCHANGE-2026-0912-005',
    preFund: true,
    bookedAt: '2026-09-12T09:00:00Z',
    settlement: {
      valueDate: '2026-09-14',
      cutoffLocal: '2026-09-14T14:00:00+03:00',
      correspondent: 'Co-operative Bank',
      ssi: { bank: 'Co-operative Bank', account: 'KES-889-1123', swift: 'COOPKENX' },
      ssiChanged: true,
      previousSsi: { bank: 'Diamond Trust Bank', account: 'KES-112-3344', swift: 'DTKEKENA' },
    },
    confirmation: { bankConfirmed: true, venueConfirmed: false, mismatch: false, mismatchFields: [] },
  },
];

// ─── Price Feeds ────────────────────────────────────────────────────────
export const mockPriceFeeds = {
  'USD/KES': { bid: 129.30, ask: 129.60, mid: 129.45, timestamp: Date.now(), latencyMs: 45 },
  'EUR/KES': { bid: 142.10, ask: 142.50, mid: 142.30, timestamp: Date.now(), latencyMs: 52 },
  'GBP/KES': { bid: 164.20, ask: 164.80, mid: 164.50, timestamp: Date.now(), latencyMs: 48 },
  'USD/UGX': { bid: 3745.00, ask: 3755.00, mid: 3750.00, timestamp: Date.now(), latencyMs: 110 },
  'EUR/UGX': { bid: 4990.00, ask: 5010.00, mid: 5000.00, timestamp: Date.now(), latencyMs: 95 },
  'GBP/UGX': { bid: 4610.00, ask: 4635.00, mid: 4622.50, timestamp: Date.now(), latencyMs: 120 },
  'USD/TZS': { bid: 2525.00, ask: 2535.00, mid: 2530.00, timestamp: Date.now(), latencyMs: 150 },
  'EUR/TZS': { bid: 3360.00, ask: 3380.00, mid: 3370.00, timestamp: Date.now() - 15000, latencyMs: 15000 }, // stale
  'USD/ZAR': { bid: 17.85, ask: 17.95, mid: 17.90, timestamp: Date.now(), latencyMs: 35 },
};

// ─── CBK Reference Rate ────────────────────────────────────────────────
export const mockCbReference = {
  source: 'Central Bank of Kenya',
  asOf: '2026-09-12T08:00:00+03:00',
  rates: {
    'USD/KES': 129.42,
    'EUR/KES': 142.25,
    'GBP/KES': 164.38,
  },
};

// ─── Book Context ───────────────────────────────────────────────────────
export const mockBookContext = {
  nopLimit: 15000000,
  nopCurrent: 10500000,
  nopUtilization: 0.70,
  positions: {
    KES: { long: 3200000, short: 2100000, net: 1100000, limit: 5000000 },
    UGX: { long: 1800000, short: 900000, net: 900000, limit: 3000000 },
    TZS: { long: 600000, short: 450000, net: 150000, limit: 2000000 },
    EUR: { long: 1400000, short: 1600000, net: -200000, limit: 4000000 },
    GBP: { long: 800000, short: 500000, net: 300000, limit: 2000000 },
    ZAR: { long: 250000, short: 100000, net: 150000, limit: 1000000 },
  },
};

// ─── Competitive Context ────────────────────────────────────────────────
export const mockCompetitiveContext = {
  small: { avgWinMargin: 0.0008, avgLossMargin: 0.0015, winRate: 0.68, sampleSize: 45 },
  medium: { avgWinMargin: 0.0005, avgLossMargin: 0.0012, winRate: 0.72, sampleSize: 28 },
  large: { avgWinMargin: 0.0003, avgLossMargin: 0.0009, winRate: 0.75, sampleSize: 12 },
};

// ─── Auto-Quote Rules ───────────────────────────────────────────────────
export const mockAutoRules = [
  {
    id: 'AR-001',
    pair: 'USD/KES',
    minAmount: 100000,
    maxAmount: 500000,
    maxMargin: 0.0010,
    tier: 'tier_1',
    enabled: true,
    createdBy: 'Grace Mwangi',
    approvedBy: 'J. Mwangi',
    version: 3,
    updatedAt: '2026-09-10T14:00:00Z',
  },
  {
    id: 'AR-002',
    pair: 'EUR/KES',
    minAmount: 100000,
    maxAmount: 1000000,
    maxMargin: 0.0012,
    tier: '*',
    enabled: true,
    createdBy: 'Grace Mwangi',
    approvedBy: 'J. Mwangi',
    version: 1,
    updatedAt: '2026-09-08T10:00:00Z',
  },
  {
    id: 'AR-003',
    pair: 'USD/UGX',
    minAmount: 50000,
    maxAmount: 300000,
    maxMargin: 3.00,
    tier: 'tier_2',
    enabled: false,
    createdBy: 'Grace Mwangi',
    approvedBy: null,
    version: 1,
    updatedAt: '2026-09-06T09:00:00Z',
  },
];

// ─── Dealer Limits ──────────────────────────────────────────────────────
export const mockDealerLimits = {
  dailyVolume: { max: 25000000, used: 8750000 },
  singleDeal: { max: 5000000 },
  counterpartyLimits: {
    'cp-001': { max: 5000000, used: 1200000 },
    'cp-002': { max: 10000000, used: 3500000 },
    'cp-003': { max: 2000000, used: 450000 },
    'cp-004': { max: 1000000, used: 200000 },
    'cp-005': { max: 8000000, used: 2100000 },
    'cp-006': { max: 3000000, used: 900000 },
  },
};

// ─── Audit Trail ────────────────────────────────────────────────────────
export const mockAuditLog = [
  { id: 'AUD-001', timestamp: '2026-09-12T12:30:00Z', action: 'quote_submitted', user: 'Grace Mwangi', entityType: 'quote', entityId: 'QT-7001', details: 'Submitted rate 129.55 for RFQ-5012 (USD/KES 450K)', ipAddress: '10.0.1.45' },
  { id: 'AUD-002', timestamp: '2026-09-12T12:28:00Z', action: 'rfq_received', user: 'System', entityType: 'rfq', entityId: 'RFQ-5001', details: 'Competitive RFQ received: USD/KES 500K from Mwamba Family Trust', ipAddress: null },
  { id: 'AUD-003', timestamp: '2026-09-12T11:22:00Z', action: 'trade_booked', user: 'Grace Mwangi', entityType: 'trade', entityId: 'TR-9005', details: 'Booked USD/KES 800K buy @ 129.30', ipAddress: '10.0.1.45' },
  { id: 'AUD-004', timestamp: '2026-09-12T11:00:00Z', action: 'quote_withdrawn', user: 'Grace Mwangi', entityType: 'quote', entityId: 'QT-7004', details: 'Withdrawn off-policy quote for RFQ-5008', ipAddress: '10.0.1.45' },
  { id: 'AUD-005', timestamp: '2026-09-12T10:30:00Z', action: 'settlement_confirmed', user: 'Grace Mwangi', entityType: 'trade', entityId: 'TR-9001', details: 'CSD payment confirmed for USD/KES 450K', ipAddress: '10.0.1.45' },
  { id: 'AUD-006', timestamp: '2026-09-12T10:00:00Z', action: 'limit_override_requested', user: 'Grace Mwangi', entityType: 'limit', entityId: 'cp-002', details: 'Requested override for counterparty limit to 12M', ipAddress: '10.0.1.45' },
  { id: 'AUD-007', timestamp: '2026-09-12T09:45:00Z', action: 'evidence_pack_accessed', user: 'Grace Mwangi', entityType: 'compliance', entityId: 'RFQ-5012', details: 'Downloaded evidence pack for RFQ-5012', ipAddress: '10.0.1.45' },
  { id: 'AUD-008', timestamp: '2026-09-12T09:30:00Z', action: 'auto_rule_updated', user: 'Grace Mwangi', entityType: 'auto_rule', entityId: 'AR-001', details: 'Updated USD/KES auto-rule v2 -> v3: maxMargin 0.0012 -> 0.0010', ipAddress: '10.0.1.45' },
  { id: 'AUD-009', timestamp: '2026-09-12T09:15:00Z', action: 'counterparty_kyc_change', user: 'System', entityType: 'counterparty', entityId: 'cp-004', details: 'Amina Diallo KYC status changed: verified -> review_due', ipAddress: null },
  { id: 'AUD-010', timestamp: '2026-09-12T09:00:00Z', action: 'session_started', user: 'Grace Mwangi', entityType: 'session', entityId: null, details: 'Logged in to Treasury Dealer dashboard', ipAddress: '10.0.1.45' },
  { id: 'AUD-011', timestamp: '2026-09-11T17:30:00Z', action: 'limit_updated', user: 'J. Mwangi', entityType: 'limit', entityId: 'KES', details: 'KES position limit changed from 4M to 5M', ipAddress: '10.0.1.20' },
  { id: 'AUD-012', timestamp: '2026-09-11T16:00:00Z', action: 'late_funds_flagged', user: 'System', entityType: 'trade', entityId: 'TR-9003', details: 'Late funds: GBP/UGX 750K past cutoff 12:00 EAT', ipAddress: null },
  { id: 'AUD-013', timestamp: '2026-09-11T15:00:00Z', action: 'ssi_change_detected', user: 'System', entityType: 'counterparty', entityId: 'cp-006', details: 'Greenfield Capital SSI changed: DTB -> Co-operative Bank', ipAddress: null },
  { id: 'AUD-014', timestamp: '2026-09-11T14:05:00Z', action: 'trade_booked', user: 'Grace Mwangi', entityType: 'trade', entityId: 'TR-9001', details: 'Booked USD/KES 450K sell @ 129.55 for Mwamba Family Trust', ipAddress: '10.0.1.45' },
  { id: 'AUD-015', timestamp: '2026-09-11T13:30:00Z', action: 'quote_accepted', user: 'System', entityType: 'quote', entityId: 'QT-7001', details: 'Quote accepted by venue: USD/KES 450K @ 129.55', ipAddress: null },
  { id: 'AUD-016', timestamp: '2026-09-11T09:00:00Z', action: 'cb_reference_published', user: 'System', entityType: 'reference', entityId: 'CBK-20260911', details: 'CBK reference rate published: USD/KES 129.38', ipAddress: null },
];
